import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@sendgrid/style-guide-grid';
import { Select } from '@sendgrid/ui-components/select';
import ProfileTooltip from './ProfileTooltip';
import withProfileInputs from '../containers/withProfileInputs';
import PROFILE from '../constants/profile';
import Styles from './g2gProfileExp.module.scss';
import profileTooltip from '../constants/profileTooltip';
import { createSelectOptions } from '../utils/createSelectOptions';

export const G2gExpEmailVolumeForm = (props) => {
  const emailVolume = [
    PROFILE.LV_EMAIL,
    PROFILE.MLV_EMAIL,
    PROFILE.MV_EMAIL,
    PROFILE.MHV_EMAIL,
    PROFILE.HLV_EMAIL,
    PROFILE.HMV_EMAIL,
    PROFILE.HV_EMAIL,
  ];

  const emailVolumeOptions = createSelectOptions(emailVolume);

  return (
    <section className={Styles['profile-component']}>
      <div className={Grid.row} data-role="email-volume-container">
        <div className={`${Styles['form-prompt']} ${Grid['col-12']}`} data-role="email-volume-prompt">
          How many emails do you send per month?
          <span className={Styles['required-dot']}>&bull;</span>
          <ProfileTooltip content={profileTooltip.EMAIL_VOLUME} />
        </div>
        <div className={Grid['col-12']}>
          <Select
            placeholder="Select a value"
            required="true"
            options={emailVolumeOptions}
            onChange={props.setEmailVolume}
          />
        </div>
      </div>
    </section>
  );
};

G2gExpEmailVolumeForm.propTypes = {
  setEmailVolume: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    emailVolume: PropTypes.string.isRequired,
  }).isRequired,
};

export default withProfileInputs(G2gExpEmailVolumeForm);
